var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({class:{ 'mdi-spin': _vm.spin, 'mdi-slow-spin': _vm.slowSpin },attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},this.$listeners),[_c('path',{attrs:{"d":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }